import { I18n } from 'react-redux-i18n';

import { NewTableColumnAction, NewTableColumnId, NewTableColumnPredefinedActionType, NewTableLoadMetadata, NewTableLoadMetadataFiltering } from "../new-table.types";

export const processColumnActions = (params: { 
  loadMetadata?: NewTableLoadMetadata;
  columnActions: Array<NewTableColumnAction>;
  currentContextMenuColumnId?: NewTableColumnId;
  filtering?: NewTableLoadMetadataFiltering;
  openFieldSelector: () => void;
  removeColumn: () => void;
  clearSorting: () => void;
  openFilters: () => void;
  clearFilter: () => void;
}) => {
  const { columnActions, currentContextMenuColumnId, filtering, loadMetadata, openFieldSelector, removeColumn, openFilters, clearFilter, clearSorting } = params;
  const filteredColumns = Object.keys(filtering?.columns || {});
  const columnFiltered = filteredColumns.some((id) => id === currentContextMenuColumnId);
  const clearFilterAction = { label: I18n.t('Clear Filter'), onClick: clearFilter };
  const withFilters = columnActions.some((x) => x.type === NewTableColumnPredefinedActionType.filters);
  const shouldShowClearFilter = withFilters && columnFiltered && filtering?.filter;
  const processedColumnActions: Array<NewTableColumnAction> = [];

  const predefinedActionsConfig: Record<NewTableColumnPredefinedActionType, { config: NewTableColumnAction; condition?: boolean; }> = {
    [NewTableColumnPredefinedActionType.filters]: { 
      config: { label: I18n.t('Filter'), onClick: openFilters },
    },
    [NewTableColumnPredefinedActionType.addColumn]: { 
      config: { label: I18n.t('Add Column'), onClick: openFieldSelector },
    },
    [NewTableColumnPredefinedActionType.deleteColumn]: { 
      config: { label: I18n.t('Delete Column'), onClick: removeColumn },
    },
    [NewTableColumnPredefinedActionType.clearSorting]: { 
      config: { label: I18n.t('Clear Sort'), onClick: clearSorting },
      condition: loadMetadata?.sorting?.id === currentContextMenuColumnId,
    },
  };
  
  columnActions.forEach(({ type, ...otherProps }) => {
    if (type && predefinedActionsConfig[type]) {
      const shouldAddPredefinedAction = predefinedActionsConfig[type].condition ?? true;

      if (!shouldAddPredefinedAction) {
        return;
      }

      const config = {
        ...predefinedActionsConfig[type].config,
        ...otherProps,
      };
      processedColumnActions.push(config);

      if (type === NewTableColumnPredefinedActionType.filters && shouldShowClearFilter) {
        processedColumnActions.push(clearFilterAction);
      }

      return;
    }

    processedColumnActions.push({
      ...otherProps,
      onClick: otherProps.onClick
    });
  });

  return processedColumnActions;
};